import React, {FC} from "react";
import {
    EuiModal,
    EuiModalHeader, EuiModalHeaderTitle, EuiModalBody
} from "@elastic/eui";
import {StripeAddPaymentMethod} from "./StripeAddPaymentMethod";
import {useSyncCardsMutation} from "../../api/rtkQueryApi/BusinessesApi";

export interface IUpdatePaymentMethodModal {
    businessId: string;
    onClose: () => void;
    onPaymentMethodUpdated?: () => void;
}

export const UpdatePaymentMethodModal: FC<IUpdatePaymentMethodModal> = props => {
    const [syncCards, syncCardsRequest] = useSyncCardsMutation()
    const onClose = () => {
        props.onClose();
    }

    const onConfirm = () => {
        syncCards({businessId: props.businessId}).then(() =>
            props.onPaymentMethodUpdated?.()
        )
    }

    return (
        <EuiModal onClose={onClose} title={'Payment Information'} style={{padding: 12}}>
            <EuiModalHeader>
                <EuiModalHeaderTitle size={'s'}>
                    Add Payment Method
                </EuiModalHeaderTitle>
            </EuiModalHeader>
            <EuiModalBody>
                <StripeAddPaymentMethod businessId={props.businessId} return_url={window.location.href} isLoading={syncCardsRequest.isLoading} onPaymentAdded={onConfirm} confirmText={'Add Card'}/>
            </EuiModalBody>
        </EuiModal>
    )
}